module.exports = __webpack_public_path__ + "img/network.8c0f3aee.png";